/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  CaseEventDTOWithUserDetails,
  GreenPlateDTO,
  HRExportLasDaysForUserParams,
  HRExportLasDaysOverviewParams,
  HRExportWorkTimeReportParams,
  HRGetGreenPlatesParams,
  HRGetLasDaysForUserParams,
  HRGetLasDaysOverviewParams,
  HRGetMissingGreenPlatesUponStartOfAssignmentParams,
  HRGetWorkTimeReportParams,
  HRMarkEventAsReadByHRParams,
  LasDaysOverviewRowDTO,
  LasDaysUserDTO,
  WorkTimeReportDTO,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useHRGetMissingGreenPlatesUponStartOfAssignmentHook = () => {
  const hRGetMissingGreenPlatesUponStartOfAssignment =
    useCustomInstance<CaseEventDTOWithUserDetails[]>();

  return useCallback(
    (
      params?: HRGetMissingGreenPlatesUponStartOfAssignmentParams,
      signal?: AbortSignal
    ) => {
      return hRGetMissingGreenPlatesUponStartOfAssignment({
        url: `/api/HR/GetMissingGreenPlatesUponStartOfAssignment`,
        method: 'GET',
        params,
        signal,
      });
    },
    [hRGetMissingGreenPlatesUponStartOfAssignment]
  );
};

export const getHRGetMissingGreenPlatesUponStartOfAssignmentQueryKey = (
  params?: HRGetMissingGreenPlatesUponStartOfAssignmentParams
) => {
  return [
    `/api/HR/GetMissingGreenPlatesUponStartOfAssignment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useHRGetMissingGreenPlatesUponStartOfAssignmentQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useHRGetMissingGreenPlatesUponStartOfAssignmentHook>
    >
  >,
  TError = unknown,
>(
  params?: HRGetMissingGreenPlatesUponStartOfAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useHRGetMissingGreenPlatesUponStartOfAssignmentHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHRGetMissingGreenPlatesUponStartOfAssignmentQueryKey(params);

  const hRGetMissingGreenPlatesUponStartOfAssignment =
    useHRGetMissingGreenPlatesUponStartOfAssignmentHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useHRGetMissingGreenPlatesUponStartOfAssignmentHook>
      >
    >
  > = ({ signal }) =>
    hRGetMissingGreenPlatesUponStartOfAssignment(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useHRGetMissingGreenPlatesUponStartOfAssignmentHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HRGetMissingGreenPlatesUponStartOfAssignmentQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useHRGetMissingGreenPlatesUponStartOfAssignmentHook>
      >
    >
  >;
export type HRGetMissingGreenPlatesUponStartOfAssignmentQueryError = unknown;

export const useHRGetMissingGreenPlatesUponStartOfAssignment = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useHRGetMissingGreenPlatesUponStartOfAssignmentHook>
    >
  >,
  TError = unknown,
>(
  params?: HRGetMissingGreenPlatesUponStartOfAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useHRGetMissingGreenPlatesUponStartOfAssignmentHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useHRGetMissingGreenPlatesUponStartOfAssignmentQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useHRMarkEventAsReadByHRHook = () => {
  const hRMarkEventAsReadByHR = useCustomInstance<Blob>();

  return useCallback(
    (params?: HRMarkEventAsReadByHRParams) => {
      return hRMarkEventAsReadByHR({
        url: `/api/HR/MarkEventAsReadByHR`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [hRMarkEventAsReadByHR]
  );
};

export const useHRMarkEventAsReadByHRMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHRMarkEventAsReadByHRHook>>>,
    TError,
    { params?: HRMarkEventAsReadByHRParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useHRMarkEventAsReadByHRHook>>>,
  TError,
  { params?: HRMarkEventAsReadByHRParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const hRMarkEventAsReadByHR = useHRMarkEventAsReadByHRHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useHRMarkEventAsReadByHRHook>>>,
    { params?: HRMarkEventAsReadByHRParams }
  > = (props) => {
    const { params } = props ?? {};

    return hRMarkEventAsReadByHR(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type HRMarkEventAsReadByHRMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHRMarkEventAsReadByHRHook>>>
>;

export type HRMarkEventAsReadByHRMutationError = unknown;

export const useHRMarkEventAsReadByHR = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHRMarkEventAsReadByHRHook>>>,
    TError,
    { params?: HRMarkEventAsReadByHRParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useHRMarkEventAsReadByHRHook>>>,
  TError,
  { params?: HRMarkEventAsReadByHRParams },
  TContext
> => {
  const mutationOptions = useHRMarkEventAsReadByHRMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useHRGetGreenPlatesHook = () => {
  const hRGetGreenPlates = useCustomInstance<GreenPlateDTO[]>();

  return useCallback(
    (params?: HRGetGreenPlatesParams, signal?: AbortSignal) => {
      return hRGetGreenPlates({
        url: `/api/HR/GetGreenPlates`,
        method: 'GET',
        params,
        signal,
      });
    },
    [hRGetGreenPlates]
  );
};

export const getHRGetGreenPlatesQueryKey = (
  params?: HRGetGreenPlatesParams
) => {
  return [`/api/HR/GetGreenPlates`, ...(params ? [params] : [])] as const;
};

export const useHRGetGreenPlatesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useHRGetGreenPlatesHook>>>,
  TError = unknown,
>(
  params?: HRGetGreenPlatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useHRGetGreenPlatesHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHRGetGreenPlatesQueryKey(params);

  const hRGetGreenPlates = useHRGetGreenPlatesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useHRGetGreenPlatesHook>>>
  > = ({ signal }) => hRGetGreenPlates(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useHRGetGreenPlatesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HRGetGreenPlatesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHRGetGreenPlatesHook>>>
>;
export type HRGetGreenPlatesQueryError = unknown;

export const useHRGetGreenPlates = <
  TData = Awaited<ReturnType<ReturnType<typeof useHRGetGreenPlatesHook>>>,
  TError = unknown,
>(
  params?: HRGetGreenPlatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useHRGetGreenPlatesHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useHRGetGreenPlatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useHRGetLasDaysOverviewHook = () => {
  const hRGetLasDaysOverview = useCustomInstance<LasDaysOverviewRowDTO[]>();

  return useCallback(
    (params?: HRGetLasDaysOverviewParams, signal?: AbortSignal) => {
      return hRGetLasDaysOverview({
        url: `/api/HR/GetLasDaysOverview`,
        method: 'GET',
        params,
        signal,
      });
    },
    [hRGetLasDaysOverview]
  );
};

export const getHRGetLasDaysOverviewQueryKey = (
  params?: HRGetLasDaysOverviewParams
) => {
  return [`/api/HR/GetLasDaysOverview`, ...(params ? [params] : [])] as const;
};

export const useHRGetLasDaysOverviewQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysOverviewHook>>>,
  TError = unknown,
>(
  params?: HRGetLasDaysOverviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysOverviewHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHRGetLasDaysOverviewQueryKey(params);

  const hRGetLasDaysOverview = useHRGetLasDaysOverviewHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysOverviewHook>>>
  > = ({ signal }) => hRGetLasDaysOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysOverviewHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HRGetLasDaysOverviewQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysOverviewHook>>>
>;
export type HRGetLasDaysOverviewQueryError = unknown;

export const useHRGetLasDaysOverview = <
  TData = Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysOverviewHook>>>,
  TError = unknown,
>(
  params?: HRGetLasDaysOverviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysOverviewHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useHRGetLasDaysOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useHRGetLasDaysForUserHook = () => {
  const hRGetLasDaysForUser = useCustomInstance<LasDaysUserDTO>();

  return useCallback(
    (params?: HRGetLasDaysForUserParams, signal?: AbortSignal) => {
      return hRGetLasDaysForUser({
        url: `/api/HR/GetLasDaysForUser`,
        method: 'GET',
        params,
        signal,
      });
    },
    [hRGetLasDaysForUser]
  );
};

export const getHRGetLasDaysForUserQueryKey = (
  params?: HRGetLasDaysForUserParams
) => {
  return [`/api/HR/GetLasDaysForUser`, ...(params ? [params] : [])] as const;
};

export const useHRGetLasDaysForUserQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysForUserHook>>>,
  TError = unknown,
>(
  params?: HRGetLasDaysForUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysForUserHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHRGetLasDaysForUserQueryKey(params);

  const hRGetLasDaysForUser = useHRGetLasDaysForUserHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysForUserHook>>>
  > = ({ signal }) => hRGetLasDaysForUser(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysForUserHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HRGetLasDaysForUserQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysForUserHook>>>
>;
export type HRGetLasDaysForUserQueryError = unknown;

export const useHRGetLasDaysForUser = <
  TData = Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysForUserHook>>>,
  TError = unknown,
>(
  params?: HRGetLasDaysForUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useHRGetLasDaysForUserHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useHRGetLasDaysForUserQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useHRExportLasDaysOverviewHook = () => {
  const hRExportLasDaysOverview = useCustomInstance<Blob>();

  return useCallback(
    (params?: HRExportLasDaysOverviewParams) => {
      return hRExportLasDaysOverview({
        url: `/api/HR/ExportLasDaysOverview`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [hRExportLasDaysOverview]
  );
};

export const useHRExportLasDaysOverviewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysOverviewHook>>>,
    TError,
    { params?: HRExportLasDaysOverviewParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysOverviewHook>>>,
  TError,
  { params?: HRExportLasDaysOverviewParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const hRExportLasDaysOverview = useHRExportLasDaysOverviewHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysOverviewHook>>>,
    { params?: HRExportLasDaysOverviewParams }
  > = (props) => {
    const { params } = props ?? {};

    return hRExportLasDaysOverview(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type HRExportLasDaysOverviewMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysOverviewHook>>>
>;

export type HRExportLasDaysOverviewMutationError = unknown;

export const useHRExportLasDaysOverview = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysOverviewHook>>>,
    TError,
    { params?: HRExportLasDaysOverviewParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysOverviewHook>>>,
  TError,
  { params?: HRExportLasDaysOverviewParams },
  TContext
> => {
  const mutationOptions = useHRExportLasDaysOverviewMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useHRExportLasDaysForUserHook = () => {
  const hRExportLasDaysForUser = useCustomInstance<Blob>();

  return useCallback(
    (params?: HRExportLasDaysForUserParams) => {
      return hRExportLasDaysForUser({
        url: `/api/HR/ExportLasDaysForUser`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [hRExportLasDaysForUser]
  );
};

export const useHRExportLasDaysForUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysForUserHook>>>,
    TError,
    { params?: HRExportLasDaysForUserParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysForUserHook>>>,
  TError,
  { params?: HRExportLasDaysForUserParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const hRExportLasDaysForUser = useHRExportLasDaysForUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysForUserHook>>>,
    { params?: HRExportLasDaysForUserParams }
  > = (props) => {
    const { params } = props ?? {};

    return hRExportLasDaysForUser(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type HRExportLasDaysForUserMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysForUserHook>>>
>;

export type HRExportLasDaysForUserMutationError = unknown;

export const useHRExportLasDaysForUser = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysForUserHook>>>,
    TError,
    { params?: HRExportLasDaysForUserParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useHRExportLasDaysForUserHook>>>,
  TError,
  { params?: HRExportLasDaysForUserParams },
  TContext
> => {
  const mutationOptions = useHRExportLasDaysForUserMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useHRGetWorkTimeReportHook = () => {
  const hRGetWorkTimeReport = useCustomInstance<WorkTimeReportDTO>();

  return useCallback(
    (params?: HRGetWorkTimeReportParams, signal?: AbortSignal) => {
      return hRGetWorkTimeReport({
        url: `/api/HR/GetWorkTimeReport`,
        method: 'GET',
        params,
        signal,
      });
    },
    [hRGetWorkTimeReport]
  );
};

export const getHRGetWorkTimeReportQueryKey = (
  params?: HRGetWorkTimeReportParams
) => {
  return [`/api/HR/GetWorkTimeReport`, ...(params ? [params] : [])] as const;
};

export const useHRGetWorkTimeReportQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useHRGetWorkTimeReportHook>>>,
  TError = unknown,
>(
  params?: HRGetWorkTimeReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useHRGetWorkTimeReportHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHRGetWorkTimeReportQueryKey(params);

  const hRGetWorkTimeReport = useHRGetWorkTimeReportHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useHRGetWorkTimeReportHook>>>
  > = ({ signal }) => hRGetWorkTimeReport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useHRGetWorkTimeReportHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HRGetWorkTimeReportQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHRGetWorkTimeReportHook>>>
>;
export type HRGetWorkTimeReportQueryError = unknown;

export const useHRGetWorkTimeReport = <
  TData = Awaited<ReturnType<ReturnType<typeof useHRGetWorkTimeReportHook>>>,
  TError = unknown,
>(
  params?: HRGetWorkTimeReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useHRGetWorkTimeReportHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useHRGetWorkTimeReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useHRExportWorkTimeReportHook = () => {
  const hRExportWorkTimeReport = useCustomInstance<Blob>();

  return useCallback(
    (params?: HRExportWorkTimeReportParams) => {
      return hRExportWorkTimeReport({
        url: `/api/HR/ExportWorkTimeReport`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [hRExportWorkTimeReport]
  );
};

export const useHRExportWorkTimeReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHRExportWorkTimeReportHook>>>,
    TError,
    { params?: HRExportWorkTimeReportParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useHRExportWorkTimeReportHook>>>,
  TError,
  { params?: HRExportWorkTimeReportParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const hRExportWorkTimeReport = useHRExportWorkTimeReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useHRExportWorkTimeReportHook>>>,
    { params?: HRExportWorkTimeReportParams }
  > = (props) => {
    const { params } = props ?? {};

    return hRExportWorkTimeReport(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type HRExportWorkTimeReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHRExportWorkTimeReportHook>>>
>;

export type HRExportWorkTimeReportMutationError = unknown;

export const useHRExportWorkTimeReport = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useHRExportWorkTimeReportHook>>>,
    TError,
    { params?: HRExportWorkTimeReportParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useHRExportWorkTimeReportHook>>>,
  TError,
  { params?: HRExportWorkTimeReportParams },
  TContext
> => {
  const mutationOptions = useHRExportWorkTimeReportMutationOptions(options);

  return useMutation(mutationOptions);
};
